import React from 'react';
import { XIcon } from './icons';
import { Pill } from './Pill';
import { painPoints } from '../data/copy';
export function PainSection() {
  return <section className="w-full bg-cream py-10 sm:py-12" aria-labelledby="pain-heading" data-id="element-168" data-mp="38x5b67kixcup">
      <div className="mx-auto max-w-5xl px-6" data-id="element-169" data-mp="2uxm3ffvmk3ix">
        <div className="text-center" data-id="element-170" data-mp="2yzh5wnpakmya">
          <Pill tone="rose" data-id="element-171" data-mp="2yyfqy855ngba">Another teaching week</Pill>
          <h2 id="pain-heading" className="mt-5 font-display text-4xl leading-tight text-charcoal sm:text-5xl" data-id="element-172" data-mp="2l8m3nu9at43o">
            You’ve lived this week before.
          </h2>
        </div>

        <div className="mx-auto mt-6 max-w-2xl rounded-3xl border border-rose-deep/20 bg-blush p-6 text-center sm:p-8" data-id="element-173" data-mp="2q0vs15urlw3u">
          <p className="font-display text-2xl leading-snug text-charcoal" data-id="element-174" data-mp="2g8znpd2359r6">
            <span className="text-wine" data-id="element-175" data-mp="2g6wpi5qs4abd">Another teaching week is starting.</span>{' '}
            Your classes are coming, and you’re still piecing combinations
            together, deciding what should come next, trying to keep every
            session fresh.
          </p>
          <p className="mt-4 font-sans text-base leading-relaxed text-ash" data-id="element-176" data-mp="3rl7lu15sk1x2">
            You know ballet. Teaching isn’t the problem. The exhausting part is
            having to organize, adapt and prepare everything around the
            teaching —{' '}
            <span className="font-medium text-wine" data-id="element-177" data-mp="gg7oegy0agh">week after week.</span>
          </p>
        </div>

        <h3 className="mt-10 text-center font-display text-3xl leading-tight text-charcoal" data-id="element-178" data-mp="38vrkjbma85fl">
          What planning from zero really{' '}
          <span className="text-wine" data-id="element-179" data-mp="33z9gkdys0b4b">costs you:</span>
        </h3>

        <ul className="mx-auto mt-6 grid max-w-4xl gap-3 sm:grid-cols-2" data-id="element-180" data-mp="3ine1zpp7r0qs">
          {painPoints.map(point => <li key={point} className="flex items-start gap-3 rounded-2xl border border-rose-deep/20 bg-rose-light/40 px-5 py-4" data-id="element-181" data-mp="3dukwv0pu1qe6">
              <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-rose-deep" strokeWidth={2.2} aria-hidden="true" data-id="element-182" data-mp="2q475zdizhxl6" />
              <span className="font-sans text-[0.9rem] leading-relaxed text-charcoal/85" data-id="element-183" data-mp="2l4ueugl2y4cs">
                {point}
              </span>
            </li>)}
        </ul>

        <p className="mx-auto mt-8 max-w-3xl rounded-3xl bg-wine px-8 py-7 text-center font-display text-xl leading-snug text-cream sm:text-2xl" data-id="element-184" data-mp="u1lw3dhm43on">
          Your commitment was never the missing piece. What’s missing is the
          structure that carries it — so your own hours stop paying for it.
        </p>
      </div>
    </section>;
}